export const paymentMethodUnavailableMessage = "Your saved payment method is no longer available. Enter your card details below, then select Save and pay.";

export function requiresPaymentMethodUpdate(failureReason?: string): boolean {
  return failureReason === "E00040" || failureReason === "MissingPaymentMethod";
}
